import React from 'react';
import { View, Text, Platform } from 'react-native';
import { useTheme } from '../../../../theme/useTheme';

const NoResultsMessage: React.FC = () => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark' && Platform.OS !== 'web';

  return (
    <View style={{ padding: 16, alignItems: 'center', justifyContent: 'center' }}>
      <Text style={{ fontSize: 16, color: isDark ? colors.text.secondary : '#555' }}>
        No employees found matching the current filters.
      </Text>
    </View>
  );
};

export default NoResultsMessage;
